import { FC, useEffect, useMemo, useState } from 'react'
import { Table, Toolbar, BreadcrumHeader, Modal, Button } from 'shared'
import { useTableHandlers } from 'hooks/useTableHandlers'
import { BreadcrumbItemType } from 'shared/molecules/Breadcrum/Breadcrum'
import { useGetClientIntegrationQuery } from '../integrationApiSlice'
import AddIntegration from '../createIntegration/CreateIntegration'
import '../../client/client.scss'
import useAuth from '../../../hooks/Auth'

const { Column, HeaderCell, Cell, StatusCell, DateTimeCell } = Table

const IntegrationList: FC = () => {
  const [openIntegrationModal, setOpenIntegrationModal] =
    useState<boolean>(false)
  const [isNotId, setIsNotId] = useState<boolean>(false)
  const { selectedClientId } = useAuth()

  const id = selectedClientId ?? ''

  useEffect(() => {
    if (!id) {
      setIsNotId(true)
    }
  }, [id])

  const { onPageChange, requestBody } = useTableHandlers({
    page: { size: 10, number: 0 }
  })
  const { data, isLoading, refetch } = useGetClientIntegrationQuery(
    { ...requestBody, id },
    { skip: !id }
  )

  const existingIntegrationSystems =
    data?.content?.map((integration) => integration.integrationSystem) || []
  useEffect(() => {
    if (id) {
      refetch()
    }
  }, [id, refetch])
  const handleIntegrationAction = () => {
    if (selectedClientId) {
      setOpenIntegrationModal(true)
    } else {
      setIsNotId(true)
    }
  }
  const handleClose = () => {
    setOpenIntegrationModal(false)
  }
  const handleTabChange = () => {}

  const COLUMNS = [
    { key: 'name', label: 'Name' },
    { key: 'integrationSystem', label: 'Integration System' },
    { key: 'targetSystemName', label: 'Target System Name' },
    { key: 'storageBucketName', label: 'Storage Bucket Name' }
  ]
  const flattenIntegrations = (IntegrationData: any[]) => {
    return IntegrationData.map((item) => {
      const target = item.targetSystem || {}
      return {
        name: item.name,
        integrationSystem: item.integrationSystem,
        storageBucketName: item.storageBucketName,
        active: item.active,
        targetSystemName: target.name,
        targetSystemCreatedOn: target.createdOn
      }
    })
  }

  const flattenedData = useMemo(
    () => flattenIntegrations(data?.content || []),
    [data]
  )

  const options = [
    {
      label: 'All',
      value: 'All',
      onClick: () => handleTabChange()
    }
  ]

  const breadcrumbItems: BreadcrumbItemType[] = [
    { label: 'Client', path: '/client' },
    { label: 'Integration', isActive: true }
  ]
  return (
    <div className="list">
      <BreadcrumHeader items={breadcrumbItems} />
      <Toolbar
        options={options}
        total={id ? (data?.totalElements ?? 0) : 0}
        buttonName="Add Integration"
        onButtonClick={handleIntegrationAction}
      />
      <div className="list__main-container">
        <Table
          data={id ? (flattenedData ?? []) : []}
          loading={isLoading}
          paginated
          pageSizeOptions={[10, 20, 30]}
          total={id ? (data?.totalElements ?? 0) : 0}
          defaultPageSize={10}
          onPageChange={onPageChange}
        >
          {COLUMNS.map((column, index) => {
            const { key, label } = column
            return (
              <Column
                flexGrow={1}
                key={key}
                align={index === 0 ? 'left' : 'center'}
                sortable
              >
                <HeaderCell>{label}</HeaderCell>
                <Cell dataKey={key} tooltip />
              </Column>
            )
          })}
          <Column align="center" key="active" sortable flexGrow={1}>
            <HeaderCell>Active</HeaderCell>

            <StatusCell
              dataKey="active"
              posDataLabel="Active"
              negDataLabel="Inactive"
            />
          </Column>
          <Column flexGrow={1} align="left">
            <HeaderCell>Created Date</HeaderCell>
            <DateTimeCell
              dataKey="targetSystemCreatedOn"
              format="dd/MMM/yy, h:mm a"
            />
          </Column>
        </Table>
      </div>
      {openIntegrationModal && (
        <AddIntegration
          open={openIntegrationModal}
          onClose={handleClose}
          existingIntegrationSystems={existingIntegrationSystems}
        />
      )}
      {isNotId && (
        <Modal
          open={isNotId}
          title=""
          onClose={() => setIsNotId(false)}
          size="calc(40% - 120px)"
          body={
            <>
              <p className="modal-title">
                Please Select the Client First From Header{' '}
              </p>
              <div className="modal-btn">
                <Button
                  className="primary btn"
                  onClick={() => {
                    setIsNotId(false)
                  }}
                >
                  Ok
                </Button>
              </div>
            </>
          }
        />
      )}
    </div>
  )
}
export default IntegrationList
